// extracted by mini-css-extract-plugin
export var actionText = "_nq-4";
export var container = "_nq-0";
export var leftSection = "_nq-1";
export var rightSection = "_nq-2";
export var settingsButton = "_nq-6";
export var settingsIcon = "_nq-7";
export var shortcut = "_nq-5";
export var shortcutGroup = "_nq-3";